// App.js - WEB
import React, { Component } from "react";
import { StyleSheet, Dimensions, Image, TouchableOpacity, View, Text } from "react-native";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Header from ".././header";
import Footer from "../footer";
import { updateDimensions, styles } from "../styles";
import { ref, get, set } from "firebase/database";
import { database } from "../firebase.js";

const API_URL = "https://hey-addy.web.app";
let email = "";

class Updated extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successMessage: "",
            newUpdates: {},
        };
    }

    updateDimensions() {
        updateDimensions();
        this.setState({});
    }

    componentDidMount() {
        this.updateDimensions();
        this.fetchNewUpdates();

        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillMount() { }

    removeChars = (string) => {
        return string.replace(/[^a-zA-Z0-9_@-]/g, "");
    };

    renderNewUpdates = (updates) => {
        const version = updates.version;
        const newUpdates = updates.updates || [];

        const renderHTML = [];
        renderHTML.push(<h4 style={{ color: "#2B1C50", marginBottom: "15px" }}>What's new in v{version} &#127873;</h4>);

        for (let i = 0; i < newUpdates.length; i++) {
            renderHTML.push(
                <div className="HorizontalFlex CenterOppositeDirectionToo">
                    <p style={{ fontSize: "22px", margin: "0px", marginRight: "12px" }}>&#9900;</p>
                    <p style={{ fontSize: "22px", margin: "0px" }}>{newUpdates[i]}</p>
                </div>
            );
        }
        return renderHTML;
    };

    fetchNewUpdates = () => {
        fetch(`${API_URL}/user/new-updates`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    // Add the success responses
                    this.setState({
                        newUpdates: response.updates,
                    });
                } else {
                    this.setState({
                        newUpdates: {
                            version: "x.x.x",
                            updates: ["Bug fixes", "Faster responses"],
                        },
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    newUpdates: {
                        version: "x.x.x",
                        updates: ["Bug fixes", "Faster responses"],
                    },
                });
            });
    };

    sendButtonPressed = () => {
        // Log this click
        window.open("https://outlook.com", "_blank");
    };

    handleEmailInput = (event) => {
        event.preventDefault();
        this.setState({
            email: event.target.value,
        });
    };

    removeChars = (string) => {
        return string.replace(/[^a-zA-Z0-9_@-]/g, "");
    };

    updateDatabase = () => {
        var id = this.removeChars(email);
        var mainRef = ref(database, "Invite/OutLook/");
        var that = this;
        // Check if reference exists or not

        get(mainRef)
            .then((snapshot) => {
                if (snapshot.hasChild(id)) {
                    // It already exists
                    alert("You have already invited these friends");
                } else {
                    // Add new
                    const userRef = ref(db, `Invite/OutLook/${id}`);

                    set(userRef, {
                        emails: email.trim(),
                    })
                        .then(() => {
                            // Success feedback
                            // Get count and update
                            that.setState({
                                successMessage: "Invited Successfully!",
                                email: "",
                            });
                            setTimeout(() => {
                                that.setState({
                                    successMessage: "",
                                });
                            }, 5000);
                        })
                        .catch((error) => {
                            // Handle errors here
                            console.error(error);
                        });
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    joinButtonPressed = () => {
        email = this.state.email.toString();
        if (email.trim() == "") {
            alert("Please enter at least one email");
        } else if (email.trim().length > 5) {
            this.updateDatabase();
        }
    };

    renderUpdateRowColView = () => {
        return (
            <div>
                <div
                    className="AboutContainer"
                    style={{
                        width: "100%",
                        paddingLeft: styles.basic.blueBgPaddingLeft,
                        justifyContent: "center",
                        paddingBottom: 80,
                    }}>
                    <Row style={{ width: "100%" }}>
                        <Col md="5">
                            {/* Text View */}
                            <View style={{ paddingTop: 90, paddingBottom: 60, width: "96%" }}>
                                <Text style={styles.headerTextNew}>Rewrite, Paraphrase, Summarize... emails</Text>
                                <br />
                                <Text
                                    style={{
                                        fontSize: 22,
                                        fontWeight: "normal",
                                        color: "#6C6684",
                                        textAlign: "left",
                                        fontFamily: "SF-Pro-Display-Regular",
                                    }}>
                                    Simply highlight any part of the emails you're composing. A variety of tools will pop up to help you
                                    enhance your text, correct any errors, or insert your own instructions for changes.
                                </Text>
                            </View>
                        </Col>

                        <Col md="7">
                            <div
                                className="VerticalFlex"
                                style={{
                                    width: "100%",
                                    height: "50%",
                                    paddingTop: "60px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "10px",
                                    boxShadow: "0px 4px 38px rgba(0, 0, 0, 0.15)",
                                }}>
                                <Image
                                    style={{ width: "100%", height: 450, backgroundColor: "#FCFCFC" }}
                                    source={"https://i.imgur.com/wLGPqZV.gif"}
                                    resizeMode="contain"
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

                <div
                    className="AboutContainer"
                    style={{
                        width: "100%",
                        paddingLeft: styles.basic.blueBgPaddingLeft,
                        justifyContent: "center",
                        paddingTop: 50,
                        paddingBottom: 90,
                    }}>
                    <Row style={{ width: "100%" }}>
                        <Col lg={{ span: 7, order: 1 }} md={{ span: 7, order: 2 }} xs={{ span: 12, order: 2 }}>
                            <div
                                className="FullParentDimensions VerticalFlex OSImageContainer"
                                style={{ alignItems: styles.mainImageAlign }}>
                                <div className="BorderRadiusImage">
                                    <Image
                                        style={{ width: "100%", height: 450, backgroundColor: "#FAFAFA" }}
                                        source={"https://i.imgur.com/VZAaXAm.gif"}
                                        resizeMode="contain"
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col lg={{ span: 5, order: 2 }} md={{ span: 5, order: 1 }} xs={{ span: 12, order: 1 }}>
                            {/* Text View */}
                            <View style={styles.airportIdentifierImageView}>
                                <Text style={styles.headerTextNew}>Minimized Compose Box</Text>
                                {/* Paragraphs, might need to dynamically load this in the future */}
                                <br />
                                <Text
                                    style={{
                                        fontSize: 22,
                                        fontWeight: "normal",
                                        color: "#6C6684",
                                        textAlign: "left",
                                        fontFamily: "SF-Pro-Display-Regular",
                                    }}>
                                    We ran a poll on minimized vs expanded compose box to see what you perfer. It was a close race. 52%
                                    want a minimized box and 48% want an expanded box. Minimize won!
                                </Text>
                                <br />
                                <Text
                                    style={{
                                        fontSize: 22,
                                        fontWeight: "normal",
                                        color: "#6C6684",
                                        textAlign: "left",
                                        fontFamily: "SF-Pro-Display-Regular",
                                    }}>
                                    Simply hover over the minimzed compose box to expand.
                                </Text>

                                <br />
                                <br />
                            </View>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    };

    MainPage() {
        return (
            <div className="AboutUsContainer" style={{ height: "100vh" }}>
                <Header />

                {/* How */}
                <div
                    className="AboutContainer"
                    style={{
                        width: "100%",
                        paddingLeft: styles.basic.blueBgPaddingLeft,
                        justifyContent: "center",
                        marginBottom: 50,
                        paddingTop: 80,
                    }}>
                    <Row style={{ width: "100%", paddingTop: 30 }}>
                        <Col md="12">
                            <br />
                            <br />
                            <div className="HorizontalFlex CenterOppositeDirectionToo CenterContents">
                                <h2 style={{ color: "#2B1C50" }}>Addy AI just got a major update</h2>
                                <h2>&nbsp; &#127881;</h2>
                            </div>

                            {this.renderUpdateRowColView()}

                            {/* <div>
                                    <Row>
                                        <Col md="6">
                                            <div className="FullParentDimensions CenterContents"
                                                style={{
                                                    backgroundColor: "#E9E9E9",
                                                    borderRadius: "10px", padding: "15px",
                                                    paddingTop: "30px",
                                                    paddingBottom: "30px"
                                                }}>
                                                <Image
                                                    style={{ width: "100%", height: 400 }}
                                                    source={require('../img/outlook_new.gif')}
                                                    resizeMode="contain"
                                                />
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="VerticalFlex" style={{
                                                width: "100%",
                                            }}>
                                                <div>
                                                    <TouchableOpacity className="SubmitButtonInstall2" onPress={() => this.sendButtonPressed()}>
                                                        <p className="SubmitTextInstall" style={{
                                                            color: "#2B1C50",
                                                            textDecoration: "underline"
                                                        }}>Try it out!</p>
                                                    </TouchableOpacity>
                                                </div>

                                                <br />
                                                <div>
                                                    <p>OR</p>
                                                </div>

                                                <div>
                                                    <h4 style={{ color: "#2B1C50", marginBottom: "7px", }}>
                                                        Invite your friends to try it
                                                    </h4>
                                                </div>

                                    

                                                <View style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "row",
                                                    height: 56,
                                                }}>
                                                    <input value={this.state.email} onChange={this.handleEmailInput} type="text"
                                                        placeholder="Enter emails separated by comma"
                                                        style={{
                                                            borderColor: 'black', borderWidth: "1px", width: "78%", height: 40, borderRadius: 8,
                                                            backgroundColor: "white", fontSize: 15, marginRight: "5px", paddingLeft: "10px"
                                                        }} />
                                                    
                                                    <TouchableOpacity className="SubmitButtonInstall" onPress={() => this.joinButtonPressed()}>
                                                        <p className="SubmitTextInstall2">Invite</p>
                                                    </TouchableOpacity>



                                                </View>

                                                <p id="successFullInvite" style={{
                                                    color: "green",
                                                }}>{this.state.successMessage}</p>
                                            </div>
                                        </Col>
                                    </Row>


                                </div> */}

                            {/* <div style={{backgroundColor: "#E9E9E9",
                        borderRadius: "10px", padding: "15px", 
                        paddingTop: "30px",
                        paddingBottom: "30px"}}>

                        {this.renderNewUpdates(this.state.newUpdates)}

                    </div> */}

                            <br />
                            <br />

                            <br />
                            <br />
                            {/* <div style={{width: "100%",
                        border: "0.5px solid grey",
                        // borderTop: "1px solid #E9E9E9",
                    }}></div> */}

                            <div
                                style={{
                                    backgroundColor: "transparent",
                                    borderRadius: "10px",
                                    padding: "15px",
                                }}>
                                <h4 style={{ color: "#2B1C50", marginBottom: "15px" }}>Please &#128591;</h4>

                                <div className="HorizontalFlex CenterOppositeDirectionToo">
                                    <p style={{ fontSize: "22px", margin: "2px", marginRight: "12px" }}>&#128154;</p>
                                    <p style={{ fontSize: "22px", margin: "2px" }}>
                                        Support us by rating &#9733; &#9733; &#9733; &#9733; &#9733; on{" "}
                                        <a
                                            href="https://chrome.google.com/webstore/detail/addy-ai-chatgpt-email-ass/gldadickgmgciakdljkcpbdepehlilfn"
                                            target="_blank">
                                            Chrome Web Store.
                                        </a>
                                    </p>
                                </div>

                                <div className="HorizontalFlex CenterOppositeDirectionToo">
                                    <p style={{ fontSize: "22px", margin: "2px", marginRight: "12px" }}>&#128036;</p>
                                    <p style={{ fontSize: "22px", margin: "2px" }}>
                                        Follow us on{" "}
                                        <a href="https://twitter.com/AddyAI_" target="_blank">
                                            Twitter
                                        </a>{" "}
                                        to stay updated.
                                    </p>
                                </div>
                                <div className="HorizontalFlex CenterOppositeDirectionToo">
                                    <p style={{ fontSize: "22px", margin: "2px", marginRight: "12px" }}>&#128075;</p>
                                    <p style={{ fontSize: "22px", margin: "2px" }}>
                                        Join our{" "}
                                        <a href="https://discord.gg/h8uCZ9CNMG" target="_blank">
                                            Discord
                                        </a>{" "}
                                        to provide feedback and suggest features.
                                    </p>
                                </div>
                            </div>

                            <br />
                            <br />
                        </Col>
                    </Row>
                </div>

                <Footer />
            </div>
        );
    }

    render() {
        return <div style={{ height: "100vh" }}>{this.MainPage()}</div>;
    }
}

export default Updated;
